import React from 'react';

import './DiscountProgramBanner.scss';

import DiscountProgramBenefits from '../DiscountProgramBenefits/DiscountProgramBenefits.jsx';
import DiscountProgramCarousel from '../DiscountProgramCarousel/DiscountProgramCarousel.jsx';

export default function DiscountProgramBanner(props) {
  return (
    <section className="discountProgramBanner">
      <div className="discountProgramBanner_benefits">
        <DiscountProgramBenefits
          link="/voordeel"
          eventTrackingCodes={props.eventTrackingCodes}
        />
      </div>

      <div className="discountProgramBanner_deals">
        {!props.hideDeal && (
          <DiscountProgramCarousel
            title="Uitgelicht"
            list={props.list}
            titleLink="/discount-program-category?uri=spotlight:frontpage"
            {...(props.isHomePage && {
              eventTrackingCodes: ['home', 'bekijken']
            })}
          />
        )}
      </div>
    </section>
  );
}
